import { post,put,del,get } from './axios'

export const licenseList = async (params) => {
  const { status, data } = await get("/license/selectLicenseListAjax", params) // licenseList

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const getLicenseDetail = async (params) => {
  const { status, data } = await get("/license/detailLicenseAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const insertLicense = async (params) => {
  const { status, data } = await post("/license/insertLicenseAjax", params, true)

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const updateLicense = async (params) => {
  const { status, data } = await post("/license/updateLicenseAjax", params, true)

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const sendAdmin = async (params) => {
  const { status, data } = await post("/license/sendAdmin", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const sendApplicant = async (params) => {
  const { status, data } = await post("/license/sendApplicant", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const exchange = async (params) => {
  const { status, data } = await get("/license/exchange", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const draftLicense = async (params) => {
  const { status, data } = await get("/license/draftLicenseAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}